export const state = () => ({
  eventList: [],
  createEventSuccess: null,
  updateEventSuccess: null,
  deleteEventSuccess: null,
  eventTypeList: [],
  createEventTypeSuccess: null,
  updateEventTypeSuccess: null,
  deleteEventTypeSuccess: null,
  eventOccurrenceCalendarList: [],
  eventOccurrenceCalendarListCancelToken: null,
  eventOccurrenceCalendarProgress: 0.0,
});
